import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { md, lg, xl, wide, xwide, xl2 } from '../common';
import { attachVisibilityBasedToggler } from '../lib/autoplayVisibilityBasedToggler';

export function initIndustries(parent) {
  if (!parent) return;

  const swiperEl = parent.querySelector('.industries__swiper');

  const swiperHandler = new Swiper(swiperEl, {
    modules: [Autoplay],
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 12,
    centeredSlides: true,
    autoplay: { delay: 2000 },
    speed: 1200,
    breakpoints: {
      [xl2]: { spaceBetween: 18 },
      [wide]: { spaceBetween: 24 },
      [xwide]: { spaceBetween: 28 },
    },
  });

  attachVisibilityBasedToggler(swiperEl, swiperHandler);
}

export function initAllIndustries() {
  const blocks = document.querySelectorAll('.js-industries');
  blocks.forEach((block) => initIndustries(block));
}
